import { MenuItem } from "@mui/material"
import { LocalizedEnum, LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { FormikDropdown } from "../../../../../../shared/components/forms/Formik"
import { CreateDisplayFormValues, DisplayTypes } from "../deviceTypes"
import { iterateStringEnum } from "../../../../../../lib/enums"

type SelectAccountingDimensionDropdownProps = Readonly<{
    isEditMode?: boolean
}>

export function SelectDeviceTypeDropdown({ isEditMode }: SelectAccountingDimensionDropdownProps) {
    return (
        <LocalizedStrict id="devices-create-or-edit-form-select-display-type" attrs={{ label: true }}>
            <FormikDropdown<CreateDisplayFormValues> fullWidth name="type" label="Display type" disabled={isEditMode}>
                {[...iterateStringEnum(DisplayTypes)].map((type) => (
                    <MenuItem key={type} value={type}>
                        <LocalizedEnum base="devices-create-or-edit-form-display-type-dropdown-item" enumValue={type}>
                            <span>{type}</span>
                        </LocalizedEnum>
                    </MenuItem>
                ))}
            </FormikDropdown>
        </LocalizedStrict>
    )
}
